import { HTTPClient } from '@abaco/web-common/src/HTTP';

export default class TracksSynchApi {
    private http: HTTPClient;
    private rootPath: string;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
    }

    public async getFreeTracks(subjectId: string, fromStartDate: string, toStartDate: string, activityId?: number): Promise<any> {
        let url = '';
        if (activityId) {
            url = `${this.rootPath}/v1/tracks-sync/context/${subjectId}/orphan/tracks?fromStartDate=${fromStartDate}&toStartDate=${toStartDate}&activityId=${activityId}`;
        } else {
            url = `${this.rootPath}/v1/tracks-sync/context/${subjectId}/orphan/tracks?fromStartDate=${fromStartDate}&toStartDate=${toStartDate}`;
        }

        const res = await this.http.get(url, {});

        return res;
    }

    public async getTrackDetail(subjectId: string, trackId: string): Promise<any> {
        const url = `${this.rootPath}/v1/tracks-sync/context/${subjectId}/orphan/track/${trackId}/details`;

        const res = await this.http.get(url, {});

        return res;
    }

    public async assignTrackToActivity(subjectId: string, trackId: string, activityId: number): Promise<any> {
        const url = `${this.rootPath}/v1/tracks-sync/context/${subjectId}/orphan/track/${trackId}/assign/activity/${activityId}`;

        const res = await this.http.put(url, {});

        return res;
    }
}
